import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OgCustomInputsService {

  constructor() { }
}
